export const USERTYPE = {
  superAdmin: 'SUPER_ADMIN',
  fundAdmin: 'FUND_ADMIN',
  investorAdmin: 'INVESTOR_ADMIN',
  regularContact: 'REGULAR_CONTACT'
};
